import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';     
import { LottieLoaderService } from 'src/app/mastermodule/service/lottie-loader.service';

@Component({
  selector: 'app-collection-app-navbar',
  templateUrl: './collection-app-navbar.component.html',
  styleUrls: ['./collection-app-navbar.component.scss'],
})
export class CollectionAppNavbarComponent implements OnInit {

  constructor(private router: Router, private lottieLoader: LottieLoaderService) { }

  ngOnInit() {}

    goToCollection() {
  //       this.lottieLoader.show();
  //   setTimeout(() => {
  //   this.router.navigate(['/collection']).then(() => {
  //     this.lottieLoader.hide(); // ✅ Hide loader after navigation
  //   });
  // }, 500); 
   this.router.navigate(['/collection']);
  }
  goToSchedule() {
  //     this.lottieLoader.show();
  //   setTimeout(() => {
  //   this.router.navigate(['/schedule']).then(() => {
  //     this.lottieLoader.hide(); // ✅ Hide loader after navigation
  //   });
  // }, 500); 
    this.router.navigate(['/schedule']);
  }
  goToEODList() {
  //     this.lottieLoader.show();
  //   setTimeout(() => {
  //   this.router.navigate(['/eodlist']).then(() => {
  //     this.lottieLoader.hide(); // ✅ Hide loader after navigation
  //   });
  // }, 500); 
    this.router.navigate(['/eodlist']);
  }
  goToHistory() {
  //     this.lottieLoader.show();
  //   setTimeout(() => {
  //   this.router.navigate(['/history']).then(() => {
  //     this.lottieLoader.hide(); // ✅ Hide loader after navigation
  //   });
  // }, 500); 
    this.router.navigate(['/history']);
  }
 goToChit() {
  //   this.lottieLoader.show();
  //   setTimeout(() => {
  //   this.router.navigate(['/chit']).then(() => {
  //     this.lottieLoader.hide(); // ✅ Hide loader after navigation
  //   });
  // }, 500); 
    this.router.navigate(['/chit']);
  }

}
